import '../styles/pages/privacy-consent.css';
import Button from '../components/Button';
import AgreeButton from '../components/AgreeButton';
import Accordion from '../components/Accordion';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyConsent = () => {
  const [allAgreed, setAllAgreed] = useState(false);
  const [personalAgreed, setPersonalAgreed] = useState(false);
  const [gpsAgreed, setGpsAgreed] = useState(false);
  const [cameraAgreed, setCameraAgreed] = useState(false);
  const navigate = useNavigate();

  const handleAllAgree = (isChecked) => {
    setAllAgreed(isChecked);
    setPersonalAgreed(isChecked);
    setGpsAgreed(isChecked);
    setCameraAgreed(isChecked);
  };

  const checkAllAgreed = () => {
    const all = personalAgreed && gpsAgreed && cameraAgreed;
    setAllAgreed(all);
  };

  const handlePersonal = (checked) => {
    setPersonalAgreed(checked);
    checkAllAgreed();
  };

  // const handleGps = (checked) => {
  //   setGpsAgreed(checked);
  //   checkAllAgreed();
  // };
  //
  // const handleCamera = (checked) => {
  //   setCameraAgreed(checked);
  //   checkAllAgreed();
  // };

    const handleGps = async (checked) => {
        if (checked) {
            try {
                await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(
                        (position) => resolve(position),
                        (error) => reject(error),
                        { enableHighAccuracy: true, timeout: 10000 }
                    );
                });
                setGpsAgreed(true);
            } catch (error) {
                alert('위치 권한을 허용하지 않으면 일부 기능이 제한됩니다.');
                setGpsAgreed(false);
            }
        } else {
            setGpsAgreed(false);
        }
        checkAllAgreed();
    };

    const handleCamera = async (checked) => {
        if (checked) {
            try {
                await navigator.mediaDevices.getUserMedia({ video: true });
                setCameraAgreed(true);
            } catch (error) {
                alert('카메라 권한을 허용하지 않으면 일부 기능이 제한됩니다.');
                setCameraAgreed(false);
            }
        } else {
            setCameraAgreed(false);
        }
        checkAllAgreed();
    };

    const handleNext = () => {
        if (personalAgreed && gpsAgreed && cameraAgreed) {
            navigate('/stepFlow');
        } else {
            alert('모든 항목에 동의해주세요.');
        }
    };

  return (
    <div className='privacy-mobile-container'>
       <div className='margin-top-section'/>
      <p className='large-text gmarket-font'>더 나은 서비스를 위해 <br />다음 약관 동의가 필요합니다</p>
      <div className='margin-bottom-section'/>
      <AgreeButton 
        checked={allAgreed}
        onChange={handleAllAgree}
      >
        모두 동의합니다.
      </AgreeButton>

      <Accordion
        title="개인정보 수집 및 이용 동의"
        content="회사는 서비스 제공을 위해 아래와 같은 개인정보를 수집 및 이용합니다.<br/><br/>

                - 수집 항목: 성명, 연락처, 이메일, 사용자 ID, 위치 정보 등<br/>
                - 이용 목적: 서비스 제공, 본인 확인, 고객 문의 응대, 계약 이행<br/>
                - 보유 및 이용 기간: 회원 탈퇴 후 1년 또는 관련 법령에 따라 보관<br/><br/>

                귀하는 개인정보 수집 및 이용에 동의하지 않을 권리가 있으며, 동의 거부 시 서비스 이용에 제한이 있을 수 있습니다."
        isChecked={personalAgreed}
        onCheck={handlePersonal}
      />
      
      <Accordion
        title="GPS 위치정보 확인 동의"
        content="회사는 서비스 제공을 위해 귀하의 위치 정보를 수집 및 이용합니다.<br/><br/>

                - 수집 항목: GPS를 통한 현재 위치 정보<br/>
                - 이용 목적: 현장 확인, 위치 기반 서비스 제공, 시설 접근 기록 생성<br/>
                - 보유 및 이용 기간: 수집 후 1년간 보관 후 자동 삭제<br/><br/>

                위치 정보 수집은 실시간 또는 비정기적으로 이루어지며, 위치 접근을 거부할 경우 일부 기능 사용이 제한될 수 있습니다."
        isChecked={gpsAgreed}
        onCheck={handleGps}
      />
      
      <Accordion
        title="전화 카메라 기능 사용 동의"
        content="회사는 다음의 목적으로 귀하의 카메라 및 촬영 기능 사용에 대한 동의를 요청합니다.<br/><br/>

                - 접근 기능: 디바이스의 카메라 사용 권한<br/>
                - 이용 목적: 현장 사진 촬영, QR 코드 및 태그 인식, 시설 기록 수집<br/>
                - 저장 방식: 앱 내 서버에 전송 및 안전하게 저장<br/><br/>

                카메라 접근을 거부할 경우 일부 기능이 제한될 수 있으며, 촬영된 모든 정보는 개인정보보호법에 따라 안전하게 처리됩니다."
        isChecked={cameraAgreed}
        onCheck={handleCamera}
      />
      
      <Button className='next-button gmarket-font' onClick={handleNext}>다음</Button>
    </div>
  );
};

export default PrivacyConsent;